import React, { useState, useEffect } from "react";
import Switch from "react-switch";

function CMSFormSwitch({ label, name, initialValue, onChange, ...rest }) {
  const [checked, setChecked] = useState(initialValue);

  useEffect(() => {
    setChecked(initialValue);
  }, [initialValue]);

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);

    if (onChange) {
      try {
        onChange(nextChecked);
      } catch (error) {
        console.error("Error in onChange:", error);
      }
    }
  };

  return (
    <div>
      {label && (
        <div className="example">
          <label className="switchLabel" htmlFor={name}>
            {label}
            <Switch
              id={name}
              onChange={handleChange}
              checked={checked}
              uncheckedIcon={false}
              checkedIcon={false}
              height={22}
              width={40}
              className="react-switch"
              {...rest}
            />
          </label>
        </div>
      )}
    </div>
  );
}

export default CMSFormSwitch;
